var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function CheckmarkCircleSolid(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18Zm2.326-11.96-3.355 4.143L6.63 8.627a1 1 0 1 0-1.514 1.307l2.124 2.461a1 1 0 0 0 1.534-.024l4.108-5.073a1 1 0 0 0-1.555-1.259Z" }) })));
}
export default CheckmarkCircleSolid;
